/*
 * @Description: 路由
 * @Version: 0.0.1
 * @Author: yujiangping
 * @Date: 2024-06-11 13:49:13
 * @LastEditors: yujiangping
 * @LastEditTime: 2025-07-01 19:05:53
 */
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    // redirect: "/home",
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
  },
  {
    path: '',
    // redirect: "/home",
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
  },
  {
    path: '/solution',
    name: 'solution',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
  },
  {
    path: '/document',
    name: 'document',
    component: () => import(/* webpackChunkName: "document" */ '../views/docsView.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import(/* webpackChunkName: "product" */ '@/views/ProductView.vue')
  },
  {
    path: '/memoryScience',
    name: 'memoryScience',
    component: () => import(/* webpackChunkName: "product" */ '@/views/ProductMemoryView.vue')
  },
    {
    path: '/aiEdu',
    name: 'aiEdu',
    component: () => import(/* webpackChunkName: "education" */ '@/views/EducationView.vue')
  },
  {
    path: '/agent',
    name: 'agent',
    component: () => import(/* webpackChunkName: "product" */ '@/views/ProductAgentView.vue')
  },
  {
    path: '/technology',
    name: 'technology',
    component: () => import(/* webpackChunkName: "technology" */ '@/views/TechView.vue')
  },
  {
    path: '/cooperate',
    name: 'cooperate',
    component: () => import(/* webpackChunkName: "cooperate" */ '@/views/CooperateView.vue')
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    component: () => import(/* webpackChunkName: "about" */ '@/views/AboutUsView.vue')
  },
  {
    path: '/trynow',
    name: 'trynow',
    component: () => import(/* webpackChunkName: "trynow" */ '@/views/TryView.vue')
  },
  {path: '/404', name: '404', meta: {title: '404'}, component: () => import(/* webpackChunkName: "notfound" */ '../views/404.vue')},//
  //官方文档复制而来
  { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import(/* webpackChunkName: "notfound" */ '../views/404.vue') },
  // if you omit the last `*`, the `/` character in params will be encoded when resolving or pushing
  { path: '/:pathMatch(.*)', name: 'bad-not-found', component: () => import(/* webpackChunkName: "notfound" */ '../views/404.vue') },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      //解决页面从列表页跳转到详情页返回,初始在原来位置
      return savePosition;
    }
    return { left: 0, top: 0 };
  },
  routes: routes,
  // routes
})

export default router
